var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"leftSideBar"},_vm._l((_vm.itemList),function(item,index){return _c('div',{key:index,staticClass:"item",class:{ item_active: _vm.activeIndex == index },on:{"click":function($event){return _vm.itemBtn(index)}}},[_vm._v("\n    "+_vm._s(item.categoryName)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }